import { HttpService, EventService, EventProvider } from '@lk/api'

export const makeEventService = (http: HttpService, baseUrl: string) =>
  new EventService(new EventProvider(http, baseUrl))
